import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { fetchContent } from "@/lib/api";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Cursor from "@/components/Cursor";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import FolkArt from "@/pages/FolkArt";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import Contact from "@/pages/Contact";
import WorkWithIpsita from "@/pages/WorkWithIpsita";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CollectionsAdmin from "@/pages/admin/CollectionsAdmin";
import ArtworksAdmin from "@/pages/admin/ArtworksAdmin";
import JournalAdmin from "@/pages/admin/JournalAdmin";
import EnquiriesAdmin from "@/pages/admin/EnquiriesAdmin";
import ContentAdmin from "@/pages/admin/ContentAdmin";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function FooterShell() {
  const [content, setContent] = useState({});
  useEffect(() => {
    fetchContent("/content").then((data) => setContent(data || {}));
  }, []);
  return <Footer content={content} />;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain min-h-screen">
      <Cursor />
      <ScrollManager />
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/collections/:slug" element={<CollectionDetail />} />
        <Route path="/folk-art" element={<FolkArt />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/work-with-ipsita" element={<WorkWithIpsita />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="collections" element={<CollectionsAdmin />} />
          <Route path="folk-art" element={<ArtworksAdmin />} />
          <Route path="journal" element={<JournalAdmin />} />
          <Route path="enquiries" element={<EnquiriesAdmin />} />
          <Route path="content" element={<ContentAdmin />} />
        </Route>
      </Routes>
      {!isAdmin && <FooterShell />}
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#1C1917", color: "#FBF8F1", border: "1px solid rgba(200,35,35,0.4)" } }} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
